// Requires: src/namespace.js
// Requires: src/register-product.ErrorManager.js

window.BOL.RegisterProduct.purchaseDateErrorManager = (function($, ErrorManager) {
	'use strict';

	var SELECTORS = {
		container: 'data-dateField-form-error',
		message:   '[data-dateField-form-error-message]',
		errorCode: 'error-code'
	};

	var DATA_ATTTIBUTES = {
		message: 'dateFieldFormErrorMessage'
	};

	return ErrorManager.create(SELECTORS, DATA_ATTTIBUTES);

})($jq, window.BOL.RegisterProduct.ErrorManager);
